import React, { useEffect, useRef, useState } from 'react';
import { HiFilter, HiPlus, HiSearch } from 'react-icons/hi';
import { TbFileTypePdf } from 'react-icons/tb';
import UsersTable from './UsersTable';
import CardWidget from './CardWidget';

const IdleUsers = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedLanguageOption, setSelectedLanguageOption] = useState("Odia");
    const [selectedLocationOption, setSelectedLocationOption] = useState("Odisha");
    const [activeTab, setActiveTab] = useState("Language Wise");
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleOptionClick = (option) => {
        if (activeTab === "Language Wise") {
            setSelectedLanguageOption(option);
        } else {
            setSelectedLocationOption(option);
        }
        setIsDropdownOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getDropdownOptions = () => {
        if (activeTab === "Language Wise") {
            return ["Odia", "English", "Tamil", "Bhojpuri"];
        } else if (activeTab === "Location Wise") {
            return ["Odisha", "Delhi", "Mumbai", "Chennai"];
        }
        return ["All Users"];
    };

    return (
        <React.Fragment>
            <div className="py-5">
                <div className="flex flex-col">
                    <div className="hidden sm:flex">
                        <button
                            className={`py-2 px-16 border-none tracking-wide bg-white text-lg rounded-tl-2xl text-navy-700 focus:outline-none ${activeTab === "Language Wise" ? "bg-gradient-to-br from-[#f8b7d5] to-white font-semibold" : "bg-transparent"
                                }`}
                            onClick={() => setActiveTab("Language Wise")}
                        >
                            Language Wise
                        </button>
                        <button
                            className={`py-2 px-16 border-none tracking-wide bg-white text-lg rounded-tr-2xl text-navy-700 focus:outline-none ${activeTab === "Location Wise" ? "bg-gradient-to-bl from-[#f8b7d5] to-white font-semibold" : "bg-transparent"
                                }`}
                            onClick={() => setActiveTab("Location Wise")}
                        >
                            Location Wise
                        </button>
                    </div>

                    <div className="sm:hidden flex justify-center space-x-4 mb-4">
                        <label className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="tab"
                                value="Language Wise"
                                checked={activeTab === "Language Wise"}
                                onChange={() => setActiveTab("Language Wise")}
                                className="form-radio text-[#c51369]"
                            />
                            <span className="text-gray-700">Language Wise</span>
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="tab"
                                value="Location Wise"
                                checked={activeTab === "Location Wise"}
                                onChange={() => setActiveTab("Location Wise")}
                                className="form-radio text-[#c51369]"
                            />
                            <span className="text-gray-700">Location Wise</span>
                        </label>
                    </div>

                    <div className="bg-white shadow-sm sm-max:rounded-2xl sm:max-w-full sm:rounded-tr-2xl sm:rounded-b-2xl p-5 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
                        {/* dropdown */}
                        <div
                            className="relative w-full md:w-1/5 md:min-w-1/5"
                            ref={dropdownRef}
                        >
                            <button
                                className="flex items-center py-2 px-4 border rounded-md text-gray-700 tracking-wide bg-white hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369] w-full"
                                onClick={toggleDropdown}
                            >
                                <HiFilter color="#c51369" className="h-5 w-5 mr-2" />
                                {activeTab === "Language Wise" ? selectedLanguageOption : selectedLocationOption}
                            </button>
                            {isDropdownOpen && (
                                <div className="absolute left-0 mt-2 w-full md:w-auto bg-white border rounded-md shadow-lg z-10 min-w-max">
                                    <ul className="py-2">
                                        {getDropdownOptions().map(option => (
                                            <li
                                                key={option}
                                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => handleOptionClick(option)}
                                            >
                                                {option}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* search bar */}
                        <div className="w-full md:w-1/2 md:flex-1 md:mx-4">
                            <div className="relative">
                                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">
                                    <HiSearch color="#c51369" className="h-5 w-5" />
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className="block w-full md:w-1/2 pl-10 py-2 px-4 border rounded-md text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#c51369]"
                                />
                            </div>
                        </div>

                        {/* plus icons */}
                        <div className="w-full md:w-auto flex items-center gap-4">
                            <button className="flex items-center justify-center w-full md:w-auto p-3 bg-[#c51369] hover:bg-[#a10f5b] hover:shadow-lg text-white rounded-full focus:outline-none">
                                <TbFileTypePdf className="h-5 w-5" />
                            </button>

                            <button className="flex items-center justify-center w-full md:w-auto p-3 bg-[#c51369] hover:bg-[#a10f5b] hover:shadow-lg text-white rounded-full focus:outline-none">
                                <HiPlus className="h-5 w-5" />
                            </button>
                        </div>
                    </div>
                </div>
                <CardWidget />
                <UsersTable />
            </div>
        </React.Fragment>
    );
};

export default IdleUsers;
